import { API_URL, FetchApi } from "@/services/service";
import User from "../models/User";



const API_BASE_URL = `${API_URL}/auth/`;
export const USERS_API_URL = `${API_URL}/auth/users/`;

export const UserServices = {
  // Créer un nouvel utilisateur
  addUser: (data: Partial<User>, token: string) =>
    FetchApi.post(`${API_BASE_URL}add-user/`, data, token),

  // Obtenir tous les utilisateurs
  getUsers: (token: string) =>
    FetchApi.get(`${USERS_API_URL}publics/`, token),


  // Obtenir toutes les notifications de l'utilisateur
  getUsersNotifications: () =>
    FetchApi.get(`${USERS_API_URL}notifications/`),

  // Marquer une notification comme lue
  markNotificationAsRead: (notificationId: number) =>
    FetchApi.post(`${USERS_API_URL}notifications/${notificationId}/mark-read/`, {}),

  // Obtenir un utilisateur par ID
  getUser: (id: number, token: string) =>
    FetchApi.get(`${USERS_API_URL}${id}/`, token),

  // Mettre à jour un utilisateur
  updateUser: (id: number, data: Partial<User>, token: string) =>
    FetchApi.put(`${USERS_API_URL}${id}/`, data, token),

  // Supprimer un utilisateur
  deleteUser: (id: number, token: string) =>
    FetchApi.delete(`${USERS_API_URL}${id}/`, token),

  // Activer/Désactiver un utilisateur
  toggleUserStatus: (id: number, token: string) =>
    FetchApi.post(`${USERS_API_URL}${id}/toggle-status/`, {}, token),

  // Obtenir les utilisateurs d'une entité
  getUserFolder: () =>
    FetchApi.get(`${USERS_API_URL}/folder/`),




  // Obtenir les utilisateurs d'une entité
  getuserEntitiesAccess: (id: number, token: string) =>
    FetchApi.get(`${API_URL}/core/entities/`, token), // !!! ce n'est pas la bonne url

  // Ajouter un utilisateur à une entité
  addUserToEntity: (entityId: number, userId: number, token: string) =>
    FetchApi.post(`${API_URL}/core/entities/${entityId}/users/`, { user_id: userId }, token),

  // ===== GESTION DES PERFORMANCES AGENTS =====

  // Obtenir les statistiques de l'équipe
  getTeamStats: (token: string) =>
    FetchApi.get(`${API_URL}/core/agent-performances/team-stats/`, token),

  // Obtenir les performances de tous les agents
  getAgentsPerformance: (token: string) =>
    FetchApi.get(`${API_URL}/core/agent-performances/agents-performance/`, token),

  // Mettre à jour les performances d'un agent
  updateAgentPerformance: (data: {
    agent_id: number;
    date: string;
    folders_processed?: number;
    folders_verified?: number;
    folders_rejected?: number;
    avg_processing_time?: number;
    quality_score?: number;
    error_rate?: number;
    current_load?: number;
  }, token: string) =>
    FetchApi.post(`${API_URL}/core/agent-performances/update-performance/`, data, token),

  // Mettre à jour les objectifs d'un agent
  updateAgentObjectives: (data: {
    agent_id: number;
    daily_objective?: number;
    weekly_objective?: number;
    monthly_objective?: number;
    skills?: string[];
  }, token: string) =>
    FetchApi.post(`${API_URL}/core/agent-objectives/update-objectives/`, data, token),
};
